import { useFeatureValue } from '@growthbook/growthbook-react';
import { useInView } from 'react-intersection-observer';

import { AnalyticsService } from '@/services';
import {
  selectActiveEpisodeId,
  selectEpisodeCompliance,
  useAppSelector,
} from '@/store';
import { ComplianceType, EpisodeCard, Referrer } from '@/types';
import { getIsEpisodeEthics } from '@/utils';

export interface EpisodeBannerComponentProps {
  episode: EpisodeCard;
  referrer?: Referrer;
  isEpisodeEthics: boolean;
  isTrailerPreviewEnabled: boolean;
  activeEpisodeId?: string;
  impressionRef: (node: Element | null | undefined) => void;
  compliance: ComplianceType;
}

export const useEpisodeBanner = ({
  episode,
  referrer,
}: {
  episode: EpisodeCard;
  referrer: Referrer;
}): EpisodeBannerComponentProps => {
  const { episodeId } = episode;

  const isLoggedOutTrailerPreviewsFeatureFlagEnabled = useFeatureValue(
    'logged-out-trailer-previews',
    false,
  );

  const compliance = useAppSelector(state =>
    selectEpisodeCompliance(state, episodeId),
  );
  const activeEpisodeId = useAppSelector(selectActiveEpisodeId);

  const { ref: impressionRef } = useInView({
    threshold: 1,
    triggerOnce: true,
    onChange: inView => {
      if (inView) {
        AnalyticsService.episodeImpression({
          episodeId,
          location: { ...referrer },
          referrer,
        });
      }
    },
  });

  const isEpisodeEthics = getIsEpisodeEthics({
    episode,
    compliance,
  });

  return {
    episode,
    referrer,
    impressionRef,
    activeEpisodeId,
    isEpisodeEthics,
    isTrailerPreviewEnabled: isLoggedOutTrailerPreviewsFeatureFlagEnabled,
    compliance,
  };
};
